// extracted by mini-css-extract-plugin
export var fileExt = "_t3-8";
export var fileIcon = "_t3-6";
export var fileLink = "_t3-5";
export var fileName = "_t3-7";
export var image = "_t3-1";
export var imageError = "_t3-3";
export var imageErrorIcon = "_t3-4";
export var imageLink = "_t3-0";
export var imageLoaded = "_t3-2";